import { useEffect } from "react";

interface AffirmConfig {
  public_api_key: string;
  script: string;
}

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    _affirm_config: AffirmConfig;
    affirm?: any;
  }
}

export const AFFIRM_PUBLIC_KEY = IS_PROD
  ? "76AITPRBF3R0ZHTY"
  : "0EOPQLOWFJZOIJAK";

export default function AffirmTag() {
  useEffect(() => {
    window._affirm_config = {
      public_api_key: AFFIRM_PUBLIC_KEY,
      script: IS_PROD
        ? "https://cdn1.affirm.com/js/v2/affirm.js"
        : "https://cdn1-sandbox.affirm.com/js/v2/affirm.js",
    };

    (function (
      m: Window,
      g: AffirmConfig,
      n: string,
      d: string,
      a: string,
      e: string,
      h: string,
      c: string,
    ) {
      const b: any = m[n] || {};
      const k = document.createElement(e) as HTMLScriptElement;
      const p = document.getElementsByTagName(e)[0];

      const l = function (a: any, b: string, c: string) {
        return function () {
          a[b]._.push([c, arguments]);
        };
      };

      b[d] = l(b, d, "set");
      const f = b[d];
      b[a] = {};
      b[a]._ = [];
      f._ = [];
      b._ = [];
      b[a][h] = l(b, a, h);
      b[c] = function () {
        b._.push([h, arguments]);
      };

      const commands =
        "set add save post open empty reset on off trigger ready setProduct".split(
          " ",
        );
      for (let i = 0; i < commands.length; i++) {
        f[commands[i]] = l(b, d, commands[i]);
      }

      const methods = ["get", "token", "url", "items"];
      for (let i = 0; i < methods.length; i++) {
        f[methods[i]] = function () {};
      }

      k.async = true;
      k.src = g[e];
      p.parentNode?.insertBefore(k, p);
      delete g[e];
      f(g);
      m[n] = b;
    })(
      window,
      window._affirm_config,
      "affirm",
      "checkout",
      "ui",
      "script",
      "ready",
      "jsReady",
    );
  }, []);

  return null;
}
